import NavigationItem from "./NavigationItem";
import { useData } from "data/data-provider";
import { useHiddenSectionLink } from "utils/useHiddenSectionLink";
import { withTrackBookingItem } from "utils/trackBooking";

function Navigation() {
  const { companyDetails } = useData();
  // Design B leaves out a link to a home page section it does not draw (1NOW-11111).
  const hiddenLink = useHiddenSectionLink();

  // `lg:!flex`, not `lg:flex`: Meta's Event Setup Tool injects its own
  // unscoped Tailwind sheet after ours, and its plain `.hidden` / `.flex`
  // then out-cascade our breakpoint variants — at 1920px the desktop nav
  // vanished and the mobile hamburger appeared. `!important` on the
  // breakpoint variant keeps ours winning. The header CTA / menu trigger and
  // Design B's desktop/mobile hero swaps carry the same `!` for the same reason.
  return (
    <ul className="nc-Navigation hidden lg:!flex lg:flex-nowrap lg:items-center lg:space-x-1 relative ">
      {/* 1NOW-11157: Track my booking sits in every site's menu. */}
      {withTrackBookingItem(companyDetails?.navigation_menu_items, companyDetails?.navigation_menu_cleared)?.reduce((acc: any, item: any) => {
        if (!hiddenLink(item?.url)) acc.push(<NavigationItem key={item.id} menuItem={item} />);

        return acc;
      }, [])}
    </ul>
  );
}

export default Navigation;
